import type { ApplicationError } from '@/api/ApplicationError';

export interface FunnelApiState {
  loading: boolean;
  error: undefined | ApplicationError;
}

export function getInitialFunnelApiState(): FunnelApiState {
  return {
    loading: false,
    error: undefined,
  };
}
